import React, { useState } from 'react';
import get from 'lodash/get';

import { env, lang } from '~/commons/config';
import ListResource from './ListResource.jsx';
import ListCompSelect from './ListCompSelect.jsx';

const api = 'api/quiz/scores/participations';

const ListScores = () => {
  const [compFilter, setCompFilter] = useState({});

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { participation: -1 },
        filter: { ...compFilter },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: 'export',
        },
        ctrls: [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
          />,
        ],
        cols: [
          {
            key: 'school.title.en',
            children: 'School',
            sortable: true,
            getter: (v, r) => lang(get(r, 'school.title')),
          },
          {
            key: 'school.district',
            children: 'Districts',
            sortable: true,
            getter: (v) => env.districts[v].zhhk,
          },
          {
            key: 'participation',
            sortable: true,
            getter: (v) => (v !== 'na'
              ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'
            ),
          },

          {
            key: 'answered',
            sortable: true,
            children: 'Completed',
          },
          {
            key: 'school.studentCount',
            sortable: true,
            children: 'Student Count (P4 - P6)',
          },
          {
            key: 'accountCount',
            children: 'Accounts',
            sortable: true,
            getter: (v) => (v || 0),
          },
          {
            key: 'enrollment',
            children: 'Enrollment %',
            sortable: true,
            getter: (v) => (v !== 'na' ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'),
          },
        ],
      }}
    />
  );
};

export default ListScores;
